
import * as storyblokRuntime$gj3ZKvuLwS1v1adajaMnz2zn5USNV_AvWMho63owncs from '/codebuild/output/src2089535083/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$TR1PykY4xTeRrPkyR1TUKPE19Z2FNK9dHl1bEx7IL_450 from '/codebuild/output/src2089535083/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$gj3ZKvuLwS1v1adajaMnz2zn5USNV_AvWMho63owncs, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$TR1PykY4xTeRrPkyR1TUKPE19Z2FNK9dHl1bEx7IL_450, defaults: {} }
}
        